import { http } from '@/utils/axios'
import qs from 'qs'

/**
 * @msg: 获取试卷详情
 */
export function getExamsPaperById(data) {
    return http({
        url: http.baseUrl('elExamsPaper/getExamsPaperById'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取试卷详情,函数名后面带3，说明使用https请求
 */
export function getExamsPaperById3(data) {
    return http({
        url: http.baseUrl3('elExamsPaper/getExamsPaperById'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取学生考试试卷详情
 */
export function getDetail(data) {
    return http({
        url: http.baseUrl('elExamsPaper/getDetail'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取学生考试试卷基本信息（阅读考试须知）
 */
export function getExamBaseInfo(data) {
    return http({
        url: http.baseUrl('elExamsPaper/getExamBaseInfo'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取学生考试试卷基本信息（阅读考试须知）
 */
export function getExamsUsersById(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getExamsUsersById'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取学生考试试卷基本信息（阅读考试须知），函数名后面带3，说明使用https请求
 */
export function getExamsUsersById3(data) {
    return http({
        url: http.baseUrl3('elExamsUsers/getExamsUsersById'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 进入考试（返回考试开始时间）
 */
export function startExamination(data) {
    return http({
        url: http.baseUrl('elExamsUsers/startExamination'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取考试试卷内容
 */
export function getExamsUsersPaperContent(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getExamsUsersPaperContent'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取考试试卷内容
 */
export function getExamsUsersPaperContent3(data) {
    return http({
        url: http.baseUrl3('elExamsUsers/getExamsUsersPaperContent'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取考试试题信息
 */
export function getExamsQuestionById(data) {
    return http({
        url: http.baseUrl('elExamsQuestion/getExamsQuestionById'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取考试试题列表
 */
export function getExamsList(data) {
    return http({
        url: http.baseUrl('elExamsQuestion/getList'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 保存考试用户的图片帧
 */
export function saveZkolHomework(filedata, data) {
    let formData = new FormData();
    formData.append('file', filedata);
    return http({
        url: http.baseUrl('elExamsUsers/savePhotoFrame'),
        method: 'post',
        params: http.params(data),
        data: formData
    })
}
/**
 * @msg: 保存考试用户的图片帧
 */
export function saveZkolHomework3(filedata, data) {
    let formData = new FormData();
    formData.append('file', filedata);
    return http({
        url: http.baseUrl3('elExamsUsers/savePhotoFrame'),
        method: 'post',
        params: http.params(data),
        data: formData
    })
}
/**
 * @msg: 实时保存考试用户作答数据（学生端）
 */
export function updateExamsUsersPaperOptions(data) {
    return http({
        url: http.baseUrl('elExamsUsers/updateExamsUsersPaperOptions'),
        method: 'post',
        params: http.params(data),
    })
}
/**
 * @msg: 实时保存考试用户作答数据（学生端）
 */
export function updateExamsUsersPaperOptions3(data) {
    return http({
        url: http.baseUrl3('elExamsUsers/updateExamsUsersPaperOptions'),
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data),
    })
}
/**
 * @msg: 提交考试试卷（学生端）
 */
export function submitExamsPaper(data) {
    return http({
        url: http.baseUrl('elExamsUsers/submitExamsPaper'),
        method: 'post',
        params: http.params(data),
    })
}
/**
 * @msg: 提交考试试卷（学生端）
 */
export function submitExamsPaper3(data) {
    return http({
        url: http.baseUrl3('elExamsUsers/submitExamsPaper'),
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data),
    })
}
/**
 * @msg: 更新剩余考试时间（学生端）
 */
export function updateRemainTime(data) {
    return http({
        url: http.baseUrl('elExamsUsers/updateRemainTime'),
        method: 'post',
        params: http.params(data),
    })
}
/**
 * @msg: 更新剩余考试时间（学生端）
 */
export function updateRemainTime3(data) {
    return http({
        url: http.baseUrl3('elExamsUsers/updateRemainTime'),
        method: 'post',
        params: http.params(data),
    })
}
/**
 * @msg: 获取考试用户记录信息
 */
export function getByIdWithBLOBs(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getByIdWithBLOBs'),
        method: 'get',
        params: http.params(data),
    })
}
/**
 * @msg: 获取考试用户记录信息
 */
export function getByIdWithBLOBs3(data) {
    return http({
        url: http.baseUrl3('elExamsUsers/getByIdWithBLOBs'),
        method: 'get',
        params: http.params(data),
    })
}
/**
* @msg: 获取考试用户的成绩列表(分页)
*/
export function getPageByExamsUsersScore(data) {
    return http({
        url: http.baseUrl('elExamsUsersScore/getPageByExamsUsersScore'),
        method: 'post',
        params: http.params(data)
    })
}
/**
* @msg: 导出成绩发布列表
*/
export function exportExcel(data) {
    return http({
        url: http.baseUrl('elExamsUsersScore/exportExcel'),
        method: 'post',
        params: http.params(data)
    })
}
/**
* @msg: 导出平时成绩模板
*/
export function exportExcelModel(data) {
    return http({
        url: http.baseUrl('elExamsUsersScore/exportExcelModel'),
        method: 'get',
        params: http.params(data)
    })
}
/**
* @msg: 导入平时成绩
*/
export function importScroce(data, filedata) {
    //文件上传
    let formData = new FormData();
    formData.append('file', filedata);
    return http({
        url: http.baseUrl('elExamsUsersScore/importExcel'),
        method: 'post',
        params: http.params(data),
        data: formData
    })
}
/**
* @msg: 成绩发布
*/
export function publishScore(data) {
    return http({
        url: http.baseUrl('elExamsUsersScore/publishScore'),
        method: 'get',
        params: http.params(data)
    })
}
/**
* @msg: 人脸验证
*/
export function faceDetect(filedata, data) {
    //文件上传
    let formData = new FormData();
    formData.append('file', filedata);
    return http({
        url: http.baseUrl('elExamsUsers/faceDetect'),
        method: 'post',
        params: http.params(data),
        data: formData
    })
}
/**
* @msg: 人脸检测
*/
export function faceDetect3(data, filedata) {
    //文件上传
    let formData = new FormData();
    formData.append('file', filedata);
    return http({
        url: http.baseUrl3('elExamsUsers/faceDetect'),
        method: 'post',
        params: http.params(data),
        data: formData
    })
}

/**
* @msg: 人脸验证
*/
export function faceMatch3(filedata, userPhoto) {
    //文件上传
    let formData = new FormData();
    formData.append('file', filedata);
    formData.append('userPhoto', userPhoto);
    return http({
        url: http.baseUrl3('elExamsUsers/faceMatch'),
        method: 'post',
        data: formData
    })
}

/**
* @msg: 人脸抓拍
*/
export function faceCatch3(filedata, data) {
    //文件上传
    let formData = new FormData();
    formData.append('file', filedata);
    return http({
        url: http.baseUrl3('elExamsUsers/faceCatch'),
        method: 'post',
        params: http.params(data),
        data: formData
    })
}